import React from 'react';
import { monthNames } from '../../Container/AttachRate/utils';
// import { EMPLYEE_ROLE, MANAGER_ROLE } from './utils';
import { formatToUSD } from '../ReusableFunctions';
import { storeNameList } from '../../Container/utils';
import { findKeyByValue } from './utils';
import AccessoryAR from './AccessoryAR';
import Tooltip from '@mui/material/Tooltip';


const TargetAchievedWidget = ({
  adjustedtarget,
  data,
  dataEvent,
  currentFilter,
  target,
  // totalAccMSRP1,
  // value1,
  // value2,
  currentMandY,
  incomingDate,
  accMSRPDataOA,
  accMSRPDataAA
}) => {

  // Calculating MSRP for Accessories
  const AA_MSRP = Object.values(accMSRPDataAA?.[1] || {}).reduce((total, { msrp }) => total + msrp, 0);
  const OA_MSRP = Object.values(accMSRPDataOA?.[1] || {}).reduce((total, { OAMsrp }) => total + OAMsrp, 0);
  let totalAccMSRP = AA_MSRP + OA_MSRP;

  if (currentFilter?.length === 2) {
    const emailPrefix = currentFilter[0] + '@vyadom.com';
    if (currentFilter[0] && currentFilter[1] === undefined) {
      totalAccMSRP =
        (accMSRPDataAA?.[1]?.[emailPrefix]?.msrp || 0) +
        (accMSRPDataOA?.[0]?.[emailPrefix]?.OAMsrp || 0);
    } else if (currentFilter[1] && currentFilter[0] === '') {
      const key = findKeyByValue(storeNameList, currentFilter[1]);
      totalAccMSRP =
        (accMSRPDataAA?.[0]?.[key]?.msrp || 0) +
        (accMSRPDataOA?.[1]?.[key]?.OAMsrp || 0);
    } else if (currentFilter[1] && currentFilter[0]) {
      const key = findKeyByValue(storeNameList, currentFilter[1]);
      totalAccMSRP =
        (accMSRPDataAA?.[2]?.[emailPrefix]?.[key]?.msrp || 0) +
        (accMSRPDataOA?.[2]?.[key]?.[emailPrefix]?.OAMsrp || 0);
    }
  }


  

  function getNumberOfDaysInMonth(monthName, year) {
    // Create a Date object with the first day of the month
    const firstDayOfMonth = new Date(
      year,
      new Date(Date.parse(monthName + ' 1, ' + year)).getMonth(),
      1,
    );

    // Move to the next month and then back one day to get the last day of the current month
    const lastDayOfMonth = new Date(year, firstDayOfMonth.getMonth() + 1, 0);

    // Return the day of the month, which represents the number of days in the month
    return lastDayOfMonth.getDate();
  }

  function mtdCalculator(target1, achieved,isDollar = true) {

    // const today = new Date().getDate();
    // console.log("today is", today) //may 10

    if (target1 === 0 || achieved === 0) return 0;

    const [monthName, year] = currentMandY;
    const monthFromCurrentDate = monthNames[new Date().getMonth()];
    
    const calculateMTD = (daysInMonth) => {
      //dollar value: convert strings like "$1,000.50" to numbers
    if (isDollar) {

      /*
      incorrect-bug= 378/1075 = 35%

      Correct Formula is below for MTD:

      its updated based on Ali's formula. 
      For example: May 13:
      totalDaysinMonth=31; target =1075, Achieved=378
      Total(MTD)
      1075/31 =34.67 *13 (may13) = 450.86
      Results=378/450.86=0.838*100
      FINAL= 83.83%
      */
      const mtdTarget = (target1 / daysInMonth) * daysInMonth;

      const mtdPercentage = parseInt(((achieved / mtdTarget) * 100).toFixed(2));
      return isNaN(mtdPercentage) ? 0 : mtdPercentage;
    }
    // For number-based targets
    const mtdTarget = (target1 / daysInMonth) * daysInMonth;

    const mtdPercentage = parseInt(((achieved / mtdTarget) * 100).toFixed(2));
      return isNaN(mtdPercentage) ? 0 : mtdPercentage;
    };

    if (monthName === monthFromCurrentDate) {
      // MAYBE BUG: returning a day before,so if it is june 01, for me start is 31 May
      const start = new Date(incomingDate?.startDate);
      const end = new Date(incomingDate?.endDate);

      // start.setDate(start.getDate() + 1);
      
      const maxDaysInMonth = new Date(year, start.getMonth() + 1, 0).getDate();
      const differenceInDays = (end - start) / (1000 * 60 * 60 * 24) + 1;

      if (differenceInDays !== maxDaysInMonth) {
        return calculateMTD(getNumberOfDaysInMonth(monthName, year), differenceInDays);
      } else {
        const currentDate = new Date();
        const daysInMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0,
        ).getDate();
        const pastDaysCount = currentDate.getDate();
        return calculateMTD(daysInMonth, pastDaysCount);
      }
    } else {
      return calculateMTD(
        getNumberOfDaysInMonth(monthName, year),
        getNumberOfDaysInMonth(monthName, year),
      );
    }
  }

  const calculateAchieved = (dataCount, dataEventCount) => {
    // If filter is active, data from events is not included ?
    // return dataCount + (currentFilter?.length === 2 ? 0 : dataEventCount);
    return dataCount + dataEventCount
  };

  const calculateColor = (target, achieved) =>
    mtdCalculator(target, achieved) < 100 ? 'rgb(248, 98, 98)' : 'rgb(41, 214, 70)';

  const renderWidget = (title, target, achieved,monthlyTarget) => {
    let displayTarget = target;
    let displayAchieved = achieved;

    if (title === 'Accessories') {
      displayTarget =
        formatToUSD(target, 0, 0) || 0;
      displayAchieved = formatToUSD(achieved) || 0;
    }
    return (
      <div className="widgetcontainer-top-left-div" key={title}>
        <div className="top-div-p">
          <p>{title}
            {/*(MTD)*/}
          </p>
        </div>
        <div className="top-div-span">
          {/*  <span style={{ color: calculateColor(target, achieved) }}>
            {mtdCalculator(target, achieved) || 0}%
          </span>*/}
          <span style={{ color: calculateColor(target, achieved) }}>
            {mtdCalculator(
              target,
              achieved,
              typeof target === 'string' && target.includes('$') // isDollar = true if target is a dollar string
            ) || 0}%
          </span>
        </div>
        <div className="top-div-bot">
         <div className="target monthly-total-tag">
            <Tooltip title="Monthly Total Target" placement="top">
              <p>MTT</p>
            </Tooltip>
              <span>{monthlyTarget || 0}</span>
          </div>
          
          <div className="target">
            <p>Target</p>
            <span>{displayTarget || 0}</span>
          </div>
          <div className="target">
            <p>Achieved</p>
            <span>{displayAchieved || 0}</span>
          </div>
        </div>
      </div>
    );
  };

  const widgetData = [
    {
      title: 'Total',
      target: adjustedtarget?.postpaidtarget + adjustedtarget?.prepaidtarget,
      achieved: calculateAchieved(
        data?.postCount + data?.preCount,
        dataEvent.postCount + dataEvent.preCount,
      ),
      monthlyTarget: target.postpaidtarget + target.prepaidtarget,
    },
    {
      title: 'Prepaid',
      target: adjustedtarget?.prepaidtarget,
      achieved: calculateAchieved(data?.preCount, dataEvent.preCount),
      monthlyTarget: target.prepaidtarget,
    },
    {
      title: 'Postpaid',
      target: adjustedtarget?.postpaidtarget,
      achieved: calculateAchieved(data?.postCount, dataEvent.postCount),
      monthlyTarget: target.postpaidtarget,
    },
    {
      title: 'Hup',
      target: adjustedtarget?.hardwareupgrade,
      achieved: calculateAchieved(data.hupCount, dataEvent.hupCount),
      monthlyTarget: target.hardwareupgrade,
    },
    {
      title: 'Addons',
      target: adjustedtarget?.addon,
      achieved: calculateAchieved(data.addonsCount, dataEvent.addonsCount),
      monthlyTarget: target.addon,
    },
    {
      title: 'Accessories',
      target: adjustedtarget?.accessories,
      // achieved: totalAccMSRP !== null ? totalAccMSRP : value1 + value2,
      achieved:totalAccMSRP,
      monthlyTarget: formatToUSD(target?.accessories , 0,0) || 0,
    },
  ];

  return (
    <div className="widgetcontainer-top">
      <div className="widgetcontainer-top-left">
        {widgetData.map(({ title, target, achieved,monthlyTarget }) => renderWidget(title, target, achieved,monthlyTarget))}
      </div>
      <div className="widgetcontainer-top-right">
        <div className="top-div-bot">
                {/* <p>Apple/Care</p>
                {/* FN:adding zero until requirements verified
                because freedom no longer offer it to their customers*/}

                {/* based on AK:May2025 Target File
                addons =everything, appleCare= PPP with applecare 
                and PPPpluswithAppleCare 
               */}
      
          <AccessoryAR data={data} incomingDate={incomingDate} currentFilter={currentFilter} />


          <div className="top-div-bot2">
            <div className="top-div-title">
              <p>Achieved</p>
            </div>
            <div className="top-div-body">
              <div className="target">
                <p>W/Device</p>
                <span>{calculateAchieved(data.withDeviceCount, dataEvent.withDeviceCount)}</span>
              </div>

              {/* showing ppp and ppp+ both */}
              <div className="target">
                 <Tooltip title="Phone Protection Plan" placement="top">
                <p>PPP</p> 
                 </Tooltip>
                <span>{calculateAchieved(data.pppCount, dataEvent.pppCount)}</span>
              </div>
             {/* New Req-june 5: to show Target and achieved both*/}
              {/*<div className="target">
                <p>Total/PPP</p>
                <span>{calculateAchieved(data.pppTotalCount, dataEvent.pppTotalCount)}</span>
              </div> 
*/}
              {/* working fine*/}
             <div className="target"> 
                <p>PPP+</p>
                <span>{calculateAchieved(data.pppPlusCount, dataEvent.pppPlusCount)}</span>
              </div>

              <div className="target">
                 <Tooltip title="Phone Protection Plan featuring Apple Care" placement="top">
                <p>AC</p> 
                 </Tooltip>
                <span>{calculateAchieved(data.appleCareCount, dataEvent.appleCareCount)} </span>
              </div>
             
              <div className="target">
                <p>AC+</p> 
                <span>{calculateAchieved(data.appleCareCountPlus, dataEvent.appleCareCountPlus)}</span>
              </div>
               
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TargetAchievedWidget;
